import type { ContentItemsQueryParams } from '@/api/v4/content-items.api';
import { fetchContentItems } from '@/api/v4/content-items.api';
import { QueryKey } from '@/config/query-client';
import { useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { contentItemsSortState } from './feed.state';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';
import { PERMISSION } from '@/user/permissions/permission.type';

export const useContentItems = () => {
  const { hasRequiredPermission } = useUserPermissions();
  const [sortParams] = useAtom(contentItemsSortState);

  const params: ContentItemsQueryParams = {
    ...sortParams,
  };

  return useQuery({
    queryKey: [QueryKey.ContentItems, params],
    queryFn: () => fetchContentItems(params),
    enabled: hasRequiredPermission(PERMISSION.MANAGE_FEED),
    staleTime: 1000 * 10 * 5,
    refetchInterval(query) {
      const data = query.state.data;
      if (!data) return false;
      const hasUnscannedImage = data.some(
        d => d.image?.scanningStatus === 'unscanned',
      );
      return hasUnscannedImage ? 2000 : false;
    },
  });
};
